import { Container, Tabs } from 'components'
import { carrierDetailsTabs, fleetDetailsTabsForAgents } from 'constants/status'
import { useState, useRef } from 'react'
import { Typography, Box } from '@mui/material'
import InsuranceCarriers from '../insuranceCarriers'
import HeartbeatDashboard from '../heartbeat'
import HeartbeatTrendsDashboard from '../heartbeatTrends'
import MileageReportingDashboard from 'pages/reporting/partial/mileageReporting'
import LocationReportingDashboard from 'pages/reporting/partial/locationReporting'
import FleetMilesByZipDashboard from '../fleetMilesByZip'
import FleetDetailsForAgents from '../fleetDetailsForAgent'
import { FleetHeartbeat, FleetPercentiles } from 'pages/connectedAccounts/partial'
import { isAgentLogin } from 'tools/auth'
import RadiusOfOperationDashboard from '../radiusOfOperation'
import SafetyEventsDashboard from '../safetyEvents'

interface ICarrierDetailProps {}

const CarrierDetails: React.FC<ICarrierDetailProps> = (props) => {
    const [carrierDetailsTab, setCarrierDetailsTab] = useState(0)

    const ref = useRef<HTMLDivElement>(null)

    const today = new Date().toLocaleDateString('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric'
    })

    const InsuranceTabPanel = (props: { print: boolean }) => {
        const { print } = props
        switch (carrierDetailsTab) {
            case 0:
                return <InsuranceCarriers print={print} />
            case 1:
                return <HeartbeatDashboard  />
            case 2:
                return <HeartbeatTrendsDashboard print={print} useCarrierFilters={true} />
            case 3:
                return <MileageReportingDashboard print={print} useCarrierFilters={true} />
            case 4:
                return <LocationReportingDashboard print={print} useCarrierFilters={true} />
            case 5:
                return <FleetMilesByZipDashboard print={print} useCarrierFilters={true} />
            case 6:
                return <RadiusOfOperationDashboard print={print} useCarrierFilters={true} />
            case 7:
                return <SafetyEventsDashboard print={print} useCarrierFilters={true} />
            default:
                return <></>
        }
    }

    const AgentTabPanel = (props: { print: boolean }) => {
        const { print } = props
        switch (carrierDetailsTab) {
            case 0:
                return <FleetDetailsForAgents print={print} />
            case 1:
                return <FleetHeartbeat print={print} />
            case 2:
                return <FleetPercentiles print={print} />
            case 3:
                return <FleetMilesByZipDashboard print={print} useCarrierFilters={true} />
            default:
                return <></>
        }
    }

    const getPageMargins = () => {
      return `@page { margin: 30px!important; }`
    }

    return (
        <Container>
            <Box sx={{ mt: 3, mb: 2, ml: 1 }}>
                <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 1 }}>
                    {localStorage.getItem('carrierName')}
                </Typography>
                <Box sx={{ display: 'flex', gap: 4 }}>
                    <Typography variant="body1" color="text.secondary">
                        DOT: 
                    {localStorage.getItem('carrierCodeType') !== "undefined" 
                        && localStorage.getItem('carrierCodeType') 
                        && localStorage.getItem('carrierCodeValue') != "undefined"
                        && localStorage.getItem('carrierCodeType')
                        && localStorage.getItem('carrierCodeType') === 'DOT'
                    ? ` US DOT ` + localStorage.getItem('carrierCodeValue')
                    : ' -'}
                    </Typography>
                    <Typography variant="body1" color="text.secondary">
                        Policy ID: 
                    {localStorage.getItem('carrierPolicyId') !== "undefined" 
                        && localStorage.getItem('carrierPolicyId') 
                        && localStorage.getItem('carrierPolicyId') !== '-' 
                    ? ' ' + localStorage.getItem('carrierPolicyId')
                    : ' -'}
                    </Typography>
                    <Typography variant="body1" color="text.secondary">
                        Effective Date: {today}
                    </Typography>
                </Box>
            </Box>
            <Tabs
                tabData={isAgentLogin() ? fleetDetailsTabsForAgents : carrierDetailsTabs}
                value={carrierDetailsTab}
                id={carrierDetailsTabs[carrierDetailsTab].label}
                handleChange={(_e, val) => setCarrierDetailsTab(val)}
                sxContainer={{
                    marginLeft: '1rem',
                    width: '100%',
                    borderBottom: '1px solid #e0e0e0',
                }}
                sxTabs={{
                    '& .MuiTabs-indicator': {
                        backgroundColor: '#0072BC',
                        height: '3px',
                    },
                }}
            />
            <Container>
                {isAgentLogin() ?
                <AgentTabPanel print={false} />
                :
                <InsuranceTabPanel print={false} />
                }
            </Container>
            <style>{getPageMargins()}</style>
        </Container>
    )                                                     
}

export default CarrierDetails